import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { UserContactStatus } from 'node_js/models/enums/user-contact-status';
import { UserContact } from 'node_js/models/tables/user_contact';
import { connLink, getCurrentDateForDB, presentSnackBar } from 'src/global';
import { UserAuthService } from './user-auth.service';
import { HttpClient } from '@angular/common/http';
import { UserContactRequest } from 'node_js/models/tables/user_contact_request';
import { FailedResponse } from 'node_js/models/failed-response.model';
import { SnackBarColor } from 'node_js/models/enums/snackbar-color';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserContactRequestInfo } from 'node_js/models/business/user_contact_request_info';

@Injectable({
  providedIn: 'root'
})
export class UserContactService {

  selectedUserContact:UserContact;

  constructor(private http:HttpClient, private matSnackBar:MatSnackBar) {
  }

  public createBlankUserContact(userId:string){
    let userContact:UserContact = {
      id: null,
      nickname: "",
      createdAt: getCurrentDateForDB(),
      status: UserContactStatus.CREATING,
      userId,
      contactUserId: null
    }
    return userContact;
  }

  denyContactRequest(userContactRequestId:string,userAuthService:UserAuthService){
    return new Promise<UserContactRequestInfo>(async (resolve,reject)=>{
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/denyContactRequest", { uid:userAuthService.currentUserComplete.user.authUid,idToken,userContactRequestId }).subscribe(
          (response:any) => {
              let apiSuccessCode = response.apiSuccessCode;
              if (apiSuccessCode && apiSuccessCode != ""){
                presentSnackBar(apiSuccessCode,SnackBarColor.SUCCESS,this.matSnackBar);
              }
              console.log(response);
              resolve(response.userContactRequestInfo);
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
              console.log("failed response", failedResponse);
              if (failedResponse.apiErrorCode){
                presentSnackBar(failedResponse.apiErrorCode,SnackBarColor.DANGER,this.matSnackBar);
              }
              reject();
          }
      )
    })
  }

  getContactRequestDetailsById(userContactRequestId:string,userAuthService:UserAuthService){
    return new Promise<UserContactRequestInfo>(async (resolve,reject)=>{
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/getContactRequestDetailsById", { uid:userAuthService.currentUserComplete.user.authUid,idToken,userContactRequestId }).subscribe(
          (response:any) => {
              let apiSuccessCode = response.apiSuccessCode;
              if (apiSuccessCode && apiSuccessCode != ""){
                presentSnackBar(apiSuccessCode,SnackBarColor.SUCCESS,this.matSnackBar);
              }
              console.log(response);
              resolve(response.userContactRequestInfo);
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
              console.log("failed response", failedResponse);
              if (failedResponse.apiErrorCode){
                presentSnackBar(failedResponse.apiErrorCode,SnackBarColor.DANGER,this.matSnackBar);
              }
              reject();
          }
      )
    })
  }
  
  createContact(userContact:UserContact,friendCode:string,contactEmail:string,userAuthService:UserAuthService,unsafeOtherUserContactRequest?:UserContactRequest){
    return new Promise<void>(async (resolve,reject)=>{
      
      // Safety check: ensure we have valid current user data
      if (!userAuthService.currentUserComplete || !userAuthService.currentUserComplete.user || !userAuthService.currentUserComplete.user.authUid) {
        console.error('[UserContactService] Cannot create contact: currentUserComplete is null or incomplete');
        console.error('[UserContactService] currentUserComplete:', userAuthService.currentUserComplete);
        reject('User data not available. Please try logging in again.');
        return;
      }
      
      console.log('[UserContactService] Creating contact with user UID:', userAuthService.currentUserComplete.user.authUid);
      
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/createContact", { uid:userAuthService.currentUserComplete.user.authUid,idToken,user:userAuthService.currentUserComplete.user,friendCode,newContact:userContact,unsafeOtherUserContactRequest,contactEmail }).subscribe(
          (response:any) => {
              let apiSuccessCode = response?.apiSuccessCode;
              if (apiSuccessCode && apiSuccessCode != ""){
                presentSnackBar(apiSuccessCode,SnackBarColor.SUCCESS,this.matSnackBar);
              }              
              console.log(response);
              resolve();
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
              console.log("failed response", failedResponse);
              let errorCode = "";
              if (failedResponse.apiErrorCode){
                errorCode = failedResponse.apiErrorCode
              }
              else if (failedResponse.genericErrorCode){
                errorCode = failedResponse.genericErrorCode
              }
              if (errorCode){
                presentSnackBar(errorCode,SnackBarColor.DANGER,this.matSnackBar);
              }
              reject();
          }
      )
    })
  }

  updateContact(userContact:UserContact,userAuthService:UserAuthService){
    return new Promise<void>(async (resolve,reject)=>{
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/updateContact", { uid:userAuthService.currentUserComplete.user.authUid,idToken,user:userAuthService.currentUserComplete.user,userContact }).subscribe(
          (response:any) => {
              let apiSuccessCode = response.apiSuccessCode;
              if (apiSuccessCode && apiSuccessCode != ""){
                presentSnackBar(apiSuccessCode,SnackBarColor.SUCCESS,this.matSnackBar);
              }              
              console.log(response);
              resolve();
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
            console.log("failed response", failedResponse);
            if (failedResponse.apiErrorCode){
              presentSnackBar(failedResponse.apiErrorCode,SnackBarColor.DANGER,this.matSnackBar);
            }
            reject();
        }
      )
    })
  }

  deleteContact(userContact:UserContact,userAuthService:UserAuthService){
    return new Promise<void>(async (resolve,reject)=>{
      let idToken = await userAuthService.createIdToken();
      this.http.post(connLink + "/deleteContact", { uid:userAuthService.currentUserComplete.user.authUid,idToken,user:userAuthService.currentUserComplete.user,userContact }).subscribe(
          (response:any) => {
              let apiSuccessCode = response.apiSuccessCode;
              if (apiSuccessCode && apiSuccessCode != ""){
                presentSnackBar(apiSuccessCode,SnackBarColor.SUCCESS,this.matSnackBar);
              }
              console.log(response);
              resolve();
          },
          (response:any) => {
            let failedResponse:FailedResponse = response.error;
            console.log("failed response", failedResponse);
            if (failedResponse.apiErrorCode){
              presentSnackBar(failedResponse.apiErrorCode,SnackBarColor.DANGER,this.matSnackBar);
            }
            reject();
        }
      )
    })
  }
}
